module.exports = require('../../es/string/repeat');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/features/string/repeat.js
// module id = zT9F
// module chunks = 0